export default __webpack_public_path__ + "static/media/img3.37b78b3a.PNG";